import { useNavigate } from 'react-router-dom';
import { useContext, useEffect } from 'react';
import { AdminAuthContext } from '../../Auth/AdminAuthProvider';
export default function AdminLogOut() {
  const auth = useContext(AdminAuthContext);
  const navigator = useNavigate();
  useEffect(() => {
    auth.logOut();
    navigator("/");
  }, [auth,navigator]);
  return (
    <div className="text-center mt-10 text-lg text-gray-600">Logging you out...</div>
  );

}